import { z } from 'zod';
import { vaultPostRequest } from '../helpers';

const responseSchema = z.object({ accepted: z.boolean(), uploaderPaused: z.boolean() });

export type IResumeImgUploaderResponse = z.infer<typeof responseSchema>;

export async function resumeImgUploaderApi(): Promise<IResumeImgUploaderResponse> {
  return vaultPostRequest({ path: '/img/resume-uploader', body: {}, schema: responseSchema });
}
